module.exports = __webpack_public_path__ + "img/ida-grey.38fa8ad5.png";